<template>
  <div>
    <el-tabs
    type="border-card"
    v-model="activeName"
    >
      <el-tab-pane
      label="查询"
      name="one"
      >
        <!-- 查询表单 -->
        <el-form
        ref="search_form"
        :model="search_form"
        label-width="130px"
        class="search_form"
        >
          <el-form-item label="出库单号" prop="orderNo4Search">
            <el-input placeholder="出库单号" v-model="search_form.orderNo4Search"></el-input>
          </el-form-item>
          <el-form-item label="参考编号" prop="soReference14Search">
            <el-input placeholder="参考编号" v-model="search_form.soReference14Search"></el-input>
          </el-form-item>
          <el-form-item label="仓库" prop="warehouseid4Search">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.warehouseid4Search"
            placeholder="请选择仓库"
            clearable
            >
              <el-option
              v-for="item in wareHouseId_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户编号" prop="customerId4Search">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.customerId4Search"
            placeholder="请选择客户"
            clearable
            filterable
            >
              <el-option
              v-for="item in customerId_list"
              :key="item.value"
              :label="item.value+'-'+item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单状态从" prop="soStatusFrom4Search">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.soStatusFrom4Search"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in soStatus_list"
              :key="item.value"
              :label="item.name"
              :value="item.value.trim()"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="到" prop="soStatusTo4Search">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.soStatusTo4Search"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in soStatus_list"
              :key="item.value"
              :label="item.name"
              :value="item.value.trim()"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单类型" prop="orderType4Search">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.orderType4Search"
            placeholder="请选择订单类型"
            clearable
            >
              <el-option
              v-for="item in docType_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="释放状态" prop="noneToSet">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.noneToSet"
            placeholder="释放状态"
            clearable
            >
              <el-option label="订单未释放" value="true"></el-option>
              <el-option label="订单释放" value="false"></el-option>
              <el-option label="订单冻结" value="false"></el-option>
              <el-option label="订单任务下发" value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收货人" prop="consigneeId4Search">
            <el-input :readyonly="true" @click.native="to_supplierId" placeholder="请选择收货人" v-model="search_form.consigneeId4Search"></el-input>
          </el-form-item>
          <el-form-item label="波次编号" prop="bociNo4Search">
            <el-input placeholder="波次编号" v-model="search_form.bociNo4Search"></el-input>
          </el-form-item>
          <el-form-item label="审核状态" prop="auditFlag">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.auditFlag"
            placeholder="请选择审核状态"
            clearable
            >
              <el-option label="未审核" value="N"></el-option>
              <el-option label="已审核" value="Y"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间从" prop="orderTime">
            <el-date-picker
            style="width: 100%;"
            v-model="search_form.orderTime"
            type="daterange"
            align="right"
            unlink-panels
            range-separator='到'
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            @change="order_time_change"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="显示关闭/取消订单" prop="showColseAndCancel">
            <el-switch
            v-model="search_form.showColseAndCancel"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="Y"
            inactive-value="N"
            ></el-switch>
          </el-form-item>
          <el-form-item>
            <el-button
            type="primary"
            icon="el-icon-search"
            @click="search_stock"
            v-if="btn_permission.includes('datahub:so:headList')||btn_permission.includes('superAdmin')"
            >查询</el-button>
            <el-button
            icon="el-icon-close"
            @click="reset_stock"
            v-if="btn_permission.includes('datahub:so:headList')||btn_permission.includes('superAdmin')"
            >重置</el-button>
          </el-form-item>
        </el-form>
        <!-- 收货人弹框 -->
        <el-dialog
        :append-to-body="true"
        :visible.sync="cneeVisible"
        title="选择收货人"
        width="60%"
        >
          <el-form :inline="true">
            <el-form-item label="关键字">
              <el-input v-model="customerKey"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="search_supplierId">搜索</el-button>
            </el-form-item>
          </el-form>
          <!-- 收货人列表 -->
          <el-table
          :data="supplierId_data"
          highlight-current-row
          border
          max-height="400"
          @row-dblclick="db_supplierId"
          >
            <el-table-column
            prop="customerId"
            label="收货人编码"
            ></el-table-column>
            <el-table-column
            prop="descrC"
            label="收货人名称"
            ></el-table-column>
          </el-table>
          <!-- 收货人列表分页 -->
          <el-pagination
          style="margin: 10px auto;"
          background
          @size-change="supplier_size_change"
          @current-change="supplier_current_change"
          :current-page="supplier_current_page"
          :page-sizes="[10,15,20,25]"
          :page-size="supplier_page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="supplier_total"
          ></el-pagination>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane
      label="列表"
      name="two"
      >
        <!-- 出库单列表 -->
        <el-table
        v-loading="list_loading"
        :data="list_data"
        highlight-current-row
        border
        max-height="400"
        @row-dblclick="stock_check_detail"
        >
          <el-table-column
          align="center"
          type="index"
          label="No"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="orderNo"
          label="订单号"
          ></el-table-column>
          <el-table-column
          show-overflow-tooltip
          align="center"
          prop="orderTypeText"
          label="订单类型"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="soStatusText"
          label="订单状态"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="customerId"
          label="客户"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="auditText"
          label="审核"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="wmsFlag"
          label="wms标记"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="warehouseId"
          label="仓库"
          ></el-table-column>
          <el-table-column
          show-overflow-tooltip
          align="center"
          prop="consigneeId"
          label="收货人"
          ></el-table-column>
          <el-table-column
          show-overflow-tooltip
          align="center"
          prop="addTime"
          label="创建时间"
          ></el-table-column>
          <el-table-column
          show-overflow-tooltip
          align="center"
          prop="soReference1"
          label="客户订单号"
          ></el-table-column>
        </el-table>
        <!-- 出库单列表分页 -->
        <el-pagination
        style="margin: 10px auto;"
        background
        @size-change="stock_size_change"
        @current-change="stock_current_change"
        :current-page="stock_current_page"
        :page-sizes="[10,15,20,25]"
        :page-size="stock_page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="stock_total"
        ></el-pagination>
      </el-tab-pane>
      <el-tab-pane
      label="明细"
      name="three"
      class="el_details_row"
      >
        <!-- 出库单明细列表 -->
        <el-table
        :data="list_data"
        highlight-current-row
        border
        max-height="400"
        @row-dblclick="db_detail_list"
        class="db_detail_list"
        ref="db_detail_list"
        >
          <el-table-column
          show-overflow-tooltip
          align="center"
          prop="soReference1"
          label="源单号"
          ></el-table-column>
          <el-table-column
          show-overflow-tooltip
          align="center"
          prop="orderNo"
          label="WMS单号"
          ></el-table-column>
          <el-table-column
          show-overflow-tooltip
          align="center"
          prop="orderTypeText"
          label="订单类型"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="auditFlag"
          label="审核"
          ></el-table-column>
        </el-table>
        <!-- 出库单明细表单 -->
        <el-form
        ref="details_form1"
        :model="details_form1"
        label-width="120px"
        class="details_form1"
        :rules="stock_rules"
        >
          <el-tabs
          type="card"
          v-model="form_active"
          >
            <el-tab-pane
            label="主信息"
            name="first"
            >
              <el-form-item label="出库单号" prop="orderNo4Post">
                <el-input :disabled="orderNo_status" v-model="details_form1.orderNo4Post" placeholder="wms出库单号"></el-input>
              </el-form-item>
              <el-form-item label="订单类型" prop="orderType4Post">
                <el-select
                style="width: 100%;"
                :popper-append-to-body="false"
                v-model="details_form1.orderType4Post"
                placeholder="请选择订单类型"
                clearable
                :disabled="orderType_status"
                >
                  <el-option
                  v-for="item in docType_list"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                  :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="订单状态" prop="orderStatus4Post">
                <el-select
                style="width: 100%;"
                :popper-append-to-body="false"
                v-model="details_form1.orderStatus4Post"
                placeholder="请选择"
                clearable
                filterable
                :disabled="orderStatus_status"
                >
                  <el-option
                  v-for="item in soStatus_list"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value.trim()"
                  :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="客户编号" prop="customerId4Post">
                <el-select
                style="width: 100%;"
                :popper-append-to-body="false"
                v-model="details_form1.customerId4Post"
                placeholder="请选择"
                clearable
                filterable
                :disabled="customerId_status"
                >
                  <el-option
                  v-for="item in customerId_list"
                  :key="item.value"
                  :label="item.value+'-'+item.name"
                  :value="item.value"
                  :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="客户订单号" prop="soReference4Post">
                <el-input :disabled="soReference_status" v-model="details_form1.soReference4Post" placeholder="客户订单号"></el-input>
              </el-form-item>
              <el-form-item label="订单创建时间" prop="addTime4Post">
                <el-input :readonly="true" :disabled="addTime_status" v-model="details_form1.addTime4Post" placeholder="订单创建时间"></el-input>
              </el-form-item>
              <el-form-item label="收货人代码" prop="consigneeId4Post">
                <el-input :readonly="true" @click.native="to_supplierId" :disabled="consigneeId_status" v-model="details_form1.consigneeId4Post"></el-input>
              </el-form-item>
              <el-form-item label="收货人" prop="consigneeName4Post">
                <el-input :readonly="true" :disabled="consigneeName_status" v-model="details_form1.consigneeName4Post"></el-input>
              </el-form-item>
              <el-form-item label="要求交货时间" prop="needFHTime4Post">
                <el-date-picker
                style="width: 100%;"
                v-model="details_form1.needFHTime4Post"
                type="date"
                placeholder="请选择"
                :disabled="needFHTime_status"
                value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="仓库" prop="warehouseid4Post">
                <el-select
                style="width: 100%;"
                :popper-append-to-body="true"
                v-model="details_form1.warehouseid4Post"
                placeholder="请选择仓库"
                clearable
                :disabled="warehouseid_status"
                >
                  <el-option
                  v-for="item in wareHouseId_list"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                  :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-tab-pane>
            <el-tab-pane
            label="收货人"
            name="second"
            >
              <el-form-item class="form1_other" label="省/市/区" prop="selectedOptions">
                <el-cascader
                :disabled="selectedOptions_status"
                style="width: 100%;"
                size="large"
                :options="options"
                v-model="details_form1.selectedOptions"
                @change="handleChange">
                </el-cascader>
              </el-form-item>
              <el-form-item class="form1_other" label="地址" prop="street4Post">
                <el-input :disabled="street_status" v-model="details_form1.street4Post" placeholder="地址、街道、门牌号"></el-input>
              </el-form-item>
              <el-form-item class="form1_other" label="详细地址" prop="allAddress4Post">
                <el-input :disabled="allAddress_status" v-model="details_form1.allAddress4Post"></el-input>
              </el-form-item>
              <el-form-item label="联系电话" prop="contact4Post">
                <el-input :disabled="contact_status" v-model="details_form1.contact4Post" placeholder="联系电话"></el-input>
              </el-form-item>
              <el-form-item label="联系人" prop="receiver4Post">
                <el-input :disabled="receiver_status" v-model="details_form1.receiver4Post" placeholder="收货人"></el-input>
              </el-form-item>
              <el-form-item label="站点" prop="stop4Post">
                <el-input :disabled="stop_status" v-model="details_form1.stop4Post"></el-input>
              </el-form-item>
              <el-form-item class="form1_other" label="备注" prop="notes4Post">
                <el-input :disabled="notes_status" v-model="details_form1.notes4Post" placeholder="备注"></el-input>
              </el-form-item>
            </el-tab-pane>
          </el-tabs>
          <el-form-item class="form1_other">
            <el-button
            size="mini"
            class="operate_btn"
            type="primary"
            icon="el-icon-plus"
            :disabled="add_stock_status"
            @click="add_stock"
            v-if="btn_permission.includes('datahub:so:addHead')||btn_permission.includes('superAdmin')"
            >增加</el-button>
            <el-button
            size="mini"
            class="operate_btn"
            type="primary"
            icon="el-icon-edit"
            :disabled="edit_stock_status"
            @click="edit_stock"
            v-if="btn_permission.includes('datahub:so:editHead')||btn_permission.includes('superAdmin')"
            >修改</el-button>
            <el-button
            size="mini"
            class="operate_btn"
            type="primary"
            icon="el-icon-delete"
            :disabled="delete_stock_status"
            @click="delete_stock"
            v-if="btn_permission.includes('datahub:so:delHead')||btn_permission.includes('superAdmin')"
            >删除</el-button>
            <el-button
            size="mini"
            class="operate_btn"
            icon="el-icon-check"
            :disabled="save_stock_status"
            @click="save_stock"
            >保存</el-button>
            <el-button
            size="mini"
            class="operate_btn"
            icon="el-icon-close"
            :disabled="cancel_stock_status"
            @click="cancel_stock"
            >取消</el-button>
            <el-button
            size="mini"
            class="operate_btn"
            type="primary"
            icon="el-icon-setting"
            :disabled="check_stock_status"
            @click="check_stock"
            v-if="btn_permission.includes('datahub:so:audit')||btn_permission.includes('superAdmin')"
            >审核</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <el-tabs
    type="border-card"
    v-model="new_active"
    >
      <el-tab-pane
      label="列表"
      name="1"
      >
        <!-- 出库单子表 -->
        <el-table
        :data="list_detail_data"
        highlight-current-row
        border
        max-height="400"
        @row-dblclick="detail_check_detail"
        ref="stock_child_list"
        >
          <el-table-column
          prop="orderLineNo"
          label="行号"
          ></el-table-column>
          <el-table-column
          prop="lineStatusText"
          label="状态"
          ></el-table-column>
          <el-table-column
          prop="sku"
          label="产品"
          ></el-table-column>
          <el-table-column
          show-overflow-tooltip
          prop="descrc"
          label="中文名称"
          ></el-table-column>
          <el-table-column
          prop="uom"
          label="单位"
          ></el-table-column>
          <el-table-column
          prop="qtyOrderedEach"
          label="订货数"
          ></el-table-column>
          <el-table-column
          prop="qtyAllocatedEach"
          label="分配数"
          ></el-table-column>
          <el-table-column
          prop="qtyPickedEach"
          label="拣货数"
          ></el-table-column>
          <el-table-column
          prop="qtyShippedEach"
          label="发货数"
          ></el-table-column>
        </el-table>
        <!-- 出库单子表分页 -->
        <el-pagination
        style="margin: 10px auto;"
        background
        @size-change="out_size_change"
        @current-change="out_current_change"
        :current-page="out_current_page"
        :page-sizes="[10,15,20]"
        :page-size="out_page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="out_total"
        ></el-pagination>
      </el-tab-pane>
      <el-tab-pane
      label="明细"
      name="2"
      class="el_details_row"
      >
        <!-- 出库单子表明细 -->
        <el-table
        :data="list_detail_data"
        highlight-current-row
        border
        max-height="400"
        @row-dblclick="db_details"
        class="db_detail_list"
        ref="stock_child_details"
        >
          <el-table-column
          prop="orderLineNo"
          label="行号"
          ></el-table-column>
          <el-table-column
          prop="sku"
          label="产品"
          ></el-table-column>
          <el-table-column
          prop="lineStatusText"
          label="行状态"
          ></el-table-column>
        </el-table>
        <el-form
        ref="detail_detail_form"
        :model="detail_detail_form"
        label-width="120px"
        class="detail_detail_form"
        :rules="child_rules"
        >
          <el-divider content-position="left">主信息</el-divider>
          <el-form-item label="行号" prop="soLineNo">
            <el-input :disabled="detailId_status" v-model="detail_detail_form.soLineNo"></el-input>
          </el-form-item>
          <el-form-item label="行状态" prop="lineStatus">
            <el-input :disabled="lineStatus_status" v-model="detail_detail_form.lineStatus"></el-input>
          </el-form-item>
          <el-form-item label="产品" prop="sku">
            <el-input :disabled="sku_status" :readonly="true" @click.native="to_sku" v-model="detail_detail_form.sku" placeholder="请选择产品"></el-input>
          </el-form-item>
          <el-form-item label="中文描述" prop="descrc">
            <el-input :disabled="skuDescrC_status" :readonly="true" v-model="detail_detail_form.descrc"></el-input>
          </el-form-item>
          <el-form-item label="规格" prop="descre">
            <el-input :disabled="skuDescrE_status" :readonly="true" v-model="detail_detail_form.descre"></el-input>
          </el-form-item>
          <el-form-item label="单位" prop="uom">
            <el-input :disabled="uom_status" :readonly="true" v-model="detail_detail_form.uom"></el-input>
          </el-form-item>
          <el-form-item label="订单数量" prop="qtyOrderedEach">
            <el-input :disabled="expectedQty_status" type="number" v-model="detail_detail_form.qtyOrderedEach"></el-input>
          </el-form-item>
          <el-form-item label="已收数量" prop="saveQty">
            <el-input :disabled="saveQty_status" type="number" v-model="detail_detail_form.saveQty"></el-input>
          </el-form-item>
          <el-divider content-position="left">批次属性</el-divider>
          <el-form-item
          v-show="item.status!=1"
          v-for="(item,index) in detail_detail_form.batch_list"
          :key="index"
          :label="item.lotName"
          :prop="'batch_list.'+index+'.lotAtt'">
            <el-input
            :type="item.lotName=='生产日期'||item.lotName=='有效期/失效期'||item.lotName=='入库日期'?'date':'text'"
            :disabled="item.batch_status"
            v-model="item.lotAtt"></el-input>
          </el-form-item>
          <el-form-item class="form1_other">
            <el-button
            size="mini"
            class="operate_btn"
            type="primary"
            icon="el-icon-plus"
            :disabled="child_add_status"
            @click="child_add"
            v-if="btn_permission.includes('datahub:so:addDetail')||btn_permission.includes('superAdmin')"
            >增加</el-button>
            <el-button
            size="mini"
            class="operate_btn"
            type="primary"
            icon="el-icon-edit"
            :disabled="child_edit_status"
            @click="child_edit"
            v-if="btn_permission.includes('datahub:so:editDetail')||btn_permission.includes('superAdmin')"
            >修改</el-button>
            <el-button
            size="mini"
            class="operate_btn"
            type="primary"
            icon="el-icon-delete"
            :disabled="child_delete_status"
            @click="child_delete"
            v-if="btn_permission.includes('datahub:so:delDetail')||btn_permission.includes('superAdmin')"
            >删除</el-button>
            <el-button
            size="mini"
            class="operate_btn"
            icon="el-icon-check"
            :disabled="child_save_status"
            @click="child_save"
            >保存</el-button>
            <el-button
            size="mini"
            class="operate_btn"
            icon="el-icon-close"
            :disabled="child_cancel_status"
            @click="child_cancel"
            >取消</el-button>
            <el-button
            size="mini"
            class="operate_btn"
            type="primary"
            icon="el-icon-download"
            :disabled="child_download_status"
            @click="child_download"
            v-if="btn_permission.includes('datahub:so:template')||btn_permission.includes('superAdmin')"
            >明细模板下载</el-button>
            <el-upload
            :action="publicAjax.extra_path+'/datahub/so/uploadDetailsFromExcel/'+row_stock_now.customerId+'/'+row_stock_now.headId"
            :auto-upload="true"
            :headers="{'scctoken':upload_token}"
            name="file"
            :on-success="success_file"
            :file-list="device_file"
            :show-file-list="false"
            :disabled="child_upload_status"
            v-if="btn_permission.includes('datahub:so:importDetail')||btn_permission.includes('superAdmin')"
            >
              <el-button
              size="mini"
              class="operate_btn"
              type="primary"
              icon="el-icon-upload2"
              :disabled="child_upload_status"
              >上传明细表格</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <!-- 产品弹框 -->
        <el-dialog
        :append-to-body="true"
        :visible.sync="productVisible"
        title="选择产品"
        width="80%"
        >
          <el-form :inline="true">
            <el-form-item label="关键字">
              <el-input placeholder="物料编码/名称/原厂编码" v-model="productKey"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="search_product">搜索</el-button>
            </el-form-item>
          </el-form>
          <!-- 产品列表 -->
          <el-table
          :data="product_data"
          highlight-current-row
          border
          max-height="400"
          ref="product_data"
          @row-dblclick="db_product"
          :row-style="row_class"
          >
            <el-table-column
            show-overflow-tooltip
            align="center"
            prop="sku"
            label="物料编码"
            ></el-table-column>
            <el-table-column
            show-overflow-tooltip
            align="center"
            prop="descrc"
            label="物料描述"
            ></el-table-column>
            <el-table-column
            show-overflow-tooltip
            align="center"
            prop="descre"
            label="规格"
            ></el-table-column>
            <el-table-column
            show-overflow-tooltip
            align="center"
            prop="reservedField04"
            label="原厂编码"
            ></el-table-column>
            <el-table-column
            show-overflow-tooltip
            align="center"
            prop="reservedField02"
            label="供应商"
            ></el-table-column>
            <el-table-column
            align="center"
            prop="enableQty"
            label="存储"
            ></el-table-column>
            <el-table-column
            align="center"
            prop="lotAtt01"
            label="生产日期"
            ></el-table-column>
            <el-table-column
            align="center"
            prop="lotAtt02"
            label="有效期"
            ></el-table-column>
            <el-table-column
            align="center"
            prop="lotAtt04"
            label="产品批号"
            ></el-table-column>
          </el-table>
          <!-- 产品列表分页 -->
          <el-pagination
          style="margin: 10px auto;"
          background
          @size-change="product_size_change"
          @current-change="product_current_change"
          :current-page="product_current_page"
          :page-sizes="[10,15,20,25]"
          :page-size="product_page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="product_total"
          ></el-pagination>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import { regionData,CodeToText,TextToCode } from "element-china-area-data";
  export default {
    data() {
      var tel_validate=(rule,value,callback)=>{
        var reg=/^(([0-9]{11})|([0-9]{3}\-[0-9]{8})|([0-9]{4}\-[0-9]{7}))$/
        if(reg.test(value)!=true){
          callback('电话格式错误')
        }else{
          callback()
        }
      }
      return{
        btn_permission:JSON.parse(localStorage.getItem(localStorage.getItem('userName')+'permission')),
        upload_token:localStorage.getItem(localStorage.getItem('userName')+'token'),
        device_file:[],
        activeName:'one',
        //出货客户编号下拉框
        customerId_list:[],
        //收货人弹框
        cneeVisible:false,
        customerKey:'',
        supplierId_data:[],
        supplier_current_page:1,
        supplier_page_size:10,
        supplier_total:0,
        //出库订单类型下拉框
        docType_list:[],
        //出库订单状态下拉框
        soStatus_list:[],
        //出库仓库下拉框
        wareHouseId_list:[],
        //查询表单
        search_form:{
          orderNo4Search:'',
          soReference14Search:'',
          warehouseid4Search:'',
          customerId4Search:'',
          soStatusFrom4Search:'',
          soStatusTo4Search:'',
          orderType4Search:'',
          noneToSet:'',
          consigneeId4Search:'',
          bociNo4Search:'',
          orderTime:'',
          addTimeFrom4Search:'',
          addTimeTo4Search:'',
          showColseAndCancel:false,
          auditFlag:''
        },
        //查询表单时间范围
        pickerOptions:{
          shortcuts:[
            {
              text:'今天',
              onClick(picker){
                const end=new Date()
                const start=new Date()
                picker.$emit('pick',[start,end])
              }
            },
            {
              text:'昨天',
              onClick(picker){
                const end=new Date()
                const start=new Date()
                start.setTime(start.getTime()-3600*1000*24)
                picker.$emit('pick',[start,end])
              }
            },
            {
              text:'最近1周',
              onClick(picker){
                const end=new Date()
                const start=new Date()
                start.setTime(start.getTime()-3600*1000*24*7)
                picker.$emit('pick',[start,end])
              }
            },
            {
              text:'最近2周',
              onClick(picker){
                const end=new Date()
                const start=new Date()
                start.setTime(start.getTime()-3600*1000*24*14)
                picker.$emit('pick',[start,end])
              }
            },
            {
              text:'最近3周',
              onClick(picker){
                const end=new Date()
                const start=new Date()
                start.setTime(start.getTime()-3600*1000*24*21)
                picker.$emit('pick',[start,end])
              }
            },
            {
              text:'最近1个月',
              onClick(picker){
                const end=new Date()
                const start=new Date()
                start.setTime(start.getTime()-3600*1000*24*30)
                picker.$emit('pick',[start,end])
              }
            },
            {
              text:'最近2个月',
              onClick(picker){
                const end=new Date()
                const start=new Date()
                start.setTime(start.getTime()-3600*1000*24*60)
                picker.$emit('pick',[start,end])
              }
            },
            {
              text:'最近3个月',
              onClick(picker){
                const end=new Date()
                const start=new Date()
                start.setTime(start.getTime()-3600*1000*24*90)
                picker.$emit('pick',[start,end])
              }
            }
          ]
        },
        //出库单列表
        list_data:[],
        //出库单懒加载
        list_loading:false,
        row_first_now:[],
        //出库单列表分页
        stock_current_page:1,
        stock_page_size:10,
        stock_total:0,
        //出库明细当前行
        row_stock_now:{},
        form_active:'first',
        //新增、修改、审核出库单判断条件
        stock_add_edit_check:'',
        //出库明细表单正则
        stock_rules:{},
        //出库明细表单新增正则
        stock_rules_add:{
          orderType4Post:[
            {required:true,message:'请选择订单类型',trigger:'change'}
          ],
          customerId4Post:[
            {required:true,message:'请选择客户编号',trigger:'change'}
          ],
          soReference4Post:[
            {required:true,message:'请选择客户订单号',trigger:'blur'}
          ],
          consigneeId4Post:[
            {required:true,message:'请选择收货人',trigger:'change'}
          ],
          needFHTime4Post:[
            {required:true,message:'请选择要求交货时间',trigger:'change'}
          ],
          warehouseid4Post:[
            {required:true,message:'请选择仓库',trigger:'change'}
          ],
          selectedOptions:[
            {required:true,message:'请选择省/市/区',trigger:'change'}
          ],
          street4Post:[
            {required:true,message:'请输入地址',trigger:'blur'}
          ],
          contact4Post:[
            {validator:tel_validate,trigger:'blur'}
          ],
          receiver4Post:[
            {required:true,message:'请输入联系人',trigger:'blur'}
          ]
        },
        //出库明细表单禁用状态
        orderNo_status:true,
        orderType_status:true,
        orderStatus_status:true,
        customerId_status:true,
        soReference_status:true,
        addTime_status:true,
        consigneeId_status:true,
        consigneeName_status:true,
        needFHTime_status:true,
        exceptFrTimeFr_status:true,
        exceptToTimeFr_status:true,
        warehouseid_status:true,
        selectedOptions_status:true,
        street_status:true,
        allAddress_status:true,
        contact_status:true,
        receiver_status:true,
        stop_status:true,
        notes_status:true,
        add_stock_status:false,
        edit_stock_status:false,
        delete_stock_status:false,
        save_stock_status:false,
        cancel_stock_status:false,
        check_stock_status:false,
        //出库单明细表单
        details_form1:{
          orderNo4Post:'',
          orderType4Post:'',
          orderStatus4Post:'',
          customerId4Post:'',
          soReference4Post:'',
          addTime4Post:'',
          consigneeId4Post:'',
          consigneeName4Post:'',
          needFHTime4Post:'',
          warehouseid4Post:'',
          selectedOptions:[],
          cprovince:'',
          ccity:'',
          cfax:'',
          street4Post:'',
          allAddress4Post:'',
          contact4Post:'',
          receiver4Post:'',
          stop4Post:'',
          notes4Post:''
        },
        options:regionData,
        //出库单子表详情
        new_active:'1',
        row_child_now:{},
        child_add_edit:'',
        list_detail_data:[],
        //出库单子表表单正则
        child_rules:{},
        child_rules_add:{
          sku:[
            {required:true,message:'请选择产品',trigger:'change'}
          ],
          qtyOrderedEach:[
            {required:true,message:'请输入订单数量',trigger:'blur'}
          ]
        },
        //出库单子表明细表单禁用状态
        detailId_status:true,
        lineStatus_status:true,
        sku_status:true,
        skuDescrC_status:true,
        skuDescrE_status:true,
        uom_status:true,
        expectedQty_status:true,
        saveQty_status:true,
        child_add_status:true,
        child_edit_status:true,
        child_delete_status:true,
        child_save_status:true,
        child_cancel_status:true,
        child_download_status:true,
        child_upload_status:true,
        //出库单子表分页
        out_current_page:1,
        out_page_size:10,
        out_total:0,
        //选择产品弹框
        productVisible:false,
        productKey:'',
        product_data:[],
        product_current_page:1,
        product_page_size:10,
        product_total:0,
        //出库单子表明细表单
        detail_detail_form:{
          soLineNo:'',
          lineStatus:'',
          sku:'',
          descrc:'',
          descre:'',
          uom:'',
          qtyOrderedEach:'',
          saveQty:'',
          batch_list:[]
        }
      }
    },
    created() {
      let that=this
      that.publicAjax.axios_set()
      //出货客户编号下拉框
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/admin/user/select/customer'
      }).then(data=>{
        if(data.data.success==true){
          that.customerId_list=data.data.data
        }
      })
      //出库仓库下拉框
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/admin/user/select/warehouse'
      }).then(data=>{
        if(data.data.success==true){
          that.wareHouseId_list=data.data.data
        }
      })
      //出库订单类型下拉框
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/wms/orderBase/select/soType'
      }).then(data=>{
        if(data.data.success==true){
          that.docType_list=data.data.data
        }
      })
      //出库订单状态下拉框
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/wms/orderBase/select/soStatus'
      }).then(data=>{
        if(data.data.success==true){
          that.soStatus_list=data.data.data
        }
      })
    },
    mounted() {

    },
    methods:{
      //数组去重
      unique(arr){
        const res=new Map()
        return arr.filter((arr) => !res.has(arr.headId) && res.set(arr.headId, 1))
      },
      //获取收货人列表
      to_supplierId(){
        this.cneeVisible=true
        //获取收货人列表
        this.get_supplierId()
      },
      //获取收货人列表
      get_supplierId(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/wms/customer/list',
          params:{
            page:that.supplier_current_page,
            limit:that.supplier_page_size,
            customerKey:that.customerKey,
            activeFlagKey:'Y',
            customerTypeKey:'CO',
            rOwnerKey:''
          }
        }).then(data=>{
          if(data.data.success==true){
            that.supplierId_data=data.data.data.list
            that.supplier_total=data.data.data.total
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //获取收货人列表
      db_supplierId(row,column,event){
        this.cneeVisible=false
        if(this.activeName=='one'){
          this.search_form.consigneeId4Search=row.customerId
        }else if(this.activeName=='three'){
          this.details_form1.consigneeId4Post=row.customerId
          this.details_form1.consigneeName4Post=row.descrC
        }
      },
      //查询收货人列表
      search_supplierId(){
        this.supplier_current_page=1
        this.supplier_page_size=10
        //获取收货人列表
        this.get_supplierId()
      },
      //收货人列表分页
      supplier_current_change(val){
        this.supplier_current_page=val
        //获取收货人列表
        this.get_supplierId()
      },
      supplier_size_change(val){
        this.supplier_page_size=val
        //获取收货人列表
        this.get_supplierId()
      },
      //订单时间范围change事件
      order_time_change(value){
        if(value!=null){
          this.search_form.addTimeFrom4Search=value[0]
          this.search_form.addTimeTo4Search=value[1]
        }else{
          this.search_form.addTimeFrom4Search=''
          this.search_form.addTimeTo4Search=''
        }
      },
      //获取出库单列表
      get_stock(){
        let that=this
        that.list_loading=true
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/datahub/so/headList',
          params:{
            page:that.stock_current_page,
            limit:that.stock_page_size,
            orderNo:that.search_form.orderNo4Search,
            soReference1:that.search_form.soReference14Search,
            warehouseId:that.search_form.warehouseid4Search,
            customerId:that.search_form.customerId4Search,
            orderType:that.search_form.orderType4Search,
            soStatusFrom:that.search_form.soStatusFrom4Search,
            soStatusTo:that.search_form.soStatusTo4Search,
            consigneeId:that.search_form.consigneeId4Search,
            addTimeFrom:that.search_form.addTimeFrom4Search,
            addTimeTo:that.search_form.addTimeTo4Search,
            auditFlag:that.search_form.auditFlag,
            showCloseAndCancel:that.search_form.showColseAndCancel
          }
        }).then(data=>{
          that.list_loading=false
          if(data.data.success==true){
            that.list_data=data.data.data.list
            that.stock_total=data.data.data.total
            if(that.row_first_now.length>0){
              that.list_data=that.row_first_now.concat(data.data.data.list)
              that.list_data=that.unique(that.list_data)
            }
            if(that.stock_add_edit_check=='edit'||that.stock_add_edit_check=='check'){
              that.list_data.forEach(item=>{
                if(item.headId==that.row_stock_now.headId){
                  that.row_stock_now=item
                }
              })
              that.db_detail_list(that.row_stock_now)
            }else{
              that.db_detail_list(that.list_data[0])
            }
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //查询表单
      search_stock(){
        this.stock_current_page=1
        this.stock_page_size=10
        this.activeName='two'
        this.row_first_now=[]
        //获取出库单列表
        this.get_stock()
      },
      //重置查询表单
      reset_stock(){
        this.$refs.search_form.resetFields()
        this.search_form.addTimeFrom4Search=''
        this.search_form.addTimeTo4Search=''
        this.stock_current_page=1
        this.stock_page_size=10
        //获取出库单列表
        this.get_stock()
      },
      //出库单列表分页
      stock_size_change(val){
        this.stock_page_size=val
        //获取出库单列表
        this.get_stock()
      },
      stock_current_change(val){
        this.stock_current_page=val
        //获取出库单列表
        this.get_stock()
      },
      //出库单列表双击事件
      stock_check_detail(row,column,event){
        this.activeName='three'
        //出库单明细行双击事件
        this.db_detail_list(row,column,event)
      },
      //出库单明细行双击事件
      db_detail_list(row,column,event){
        this.stock_add_edit_check=''
        this.out_current_page=1
        this.out_page_size=10
        this.stock_rules={}
        if(row==undefined){
          return false
        }
        //出库明细表单禁用状态
        this.orderNo_status=true
        this.orderType_status=true
        this.orderStatus_status=true
        this.customerId_status=true
        this.soReference_status=true
        this.addTime_status=true
        this.consigneeId_status=true
        this.consigneeName_status=true
        this.needFHTime_status=true
        this.exceptFrTimeFr_status=true
        this.exceptToTimeFr_status=true
        this.warehouseid_status=true
        this.selectedOptions_status=true
        this.street_status=true
        this.allAddress_status=true
        this.contact_status=true
        this.receiver_status=true
        this.stop_status=true
        this.notes_status=true
        if(row.auditFlag=='N'){
          this.add_stock_status=false
          this.edit_stock_status=false
          this.delete_stock_status=false
          this.save_stock_status=true
          this.cancel_stock_status=true
          this.check_stock_status=false
        }else{
          this.add_stock_status=false
          this.edit_stock_status=true
          this.delete_stock_status=true
          this.save_stock_status=true
          this.cancel_stock_status=true
          this.check_stock_status=true
        }
        //选中当前行
        this.$refs.db_detail_list.setCurrentRow(row)
        //重置明细表单校验
        this.$refs.details_form1.clearValidate()
        //获取出库单明细当前行数据
        this.row_stock_now=row
        //获取出库单子表列表
        this.get_stock_child()
        //明细表单回显
        this.details_form1={
          orderNo4Post:row.orderNo,
          orderType4Post:row.orderType,
          orderStatus4Post:row.soStatus,
          customerId4Post:row.customerId,
          soReference4Post:row.soReference1,
          addTime4Post:row.addTime,
          consigneeId4Post:row.consigneeId,
          consigneeName4Post:row.consigneeName,
          needFHTime4Post:row.requiredDeliveryTime,
          warehouseid4Post:row.warehouseId,
          selectedOptions:[
            isNaN(row.cprovince)==true?TextToCode[row.cprovince].code:row.cprovince,
            isNaN(row.ccity)==true?TextToCode[row.cprovince][row.ccity].code:row.ccity,
            isNaN(row.cfax)==true?TextToCode[row.cprovince][row.ccity][row.cfax].code:row.cfax
          ],
          // cprovince:CodeToText[row.cprovince],
          // ccity:CodeToText[row.ccity],
          // cfax:CodeToText[row.cfax],
          street4Post:row.caddress2,
          allAddress4Post:row.caddress1,
          contact4Post:row.ctel1,
          receiver4Post:row.ccontact,
          stop4Post:row.stop,
          notes4Post:row.notes
        }
      },
      //省市区三级联动
      handleChange(val){

      },
      //新增出库单前置
      add_stock(){
        this.row_first_now=[]
        this.details_form1.addTime4Post=this.publicAjax.genDateFromStamp(new Date().getTime())
        this.stock_add_edit_check='add'
        //出库明细表单禁用状态
        this.orderType_status=false
        this.customerId_status=false
        this.soReference_status=false
        this.addTime_status=false
        this.consigneeId_status=false
        this.consigneeName_status=false
        this.needFHTime_status=false
        this.warehouseid_status=false
        this.selectedOptions_status=false
        this.street_status=false
        this.allAddress_status=false
        this.contact_status=false
        this.receiver_status=false
        this.stop_status=false
        this.notes_status=false
        if(this.row_stock_now.auditFlag=='N'){
          this.add_stock_status=true
          this.edit_stock_status=true
          this.delete_stock_status=true
          this.save_stock_status=false
          this.cancel_stock_status=false
          this.check_stock_status=false
        }else{
          this.add_stock_status=true
          this.edit_stock_status=true
          this.delete_stock_status=true
          this.save_stock_status=false
          this.cancel_stock_status=false
          this.check_stock_status=true
        }
        //出库明细表单新增正则
        this.stock_rules=this.stock_rules_add
        //重置出库明细表单
        this.details_form1.orderNo4Post=''
        this.details_form1.orderType4Post=''
        this.details_form1.orderStatus4Post=''
        this.details_form1.customerId4Post=''
        this.details_form1.soReference4Post=''
        this.details_form1.consigneeId4Post=''
        this.details_form1.consigneeName4Post=''
        this.details_form1.needFHTime4Post=''
        this.details_form1.warehouseid4Post=''
        this.details_form1.selectedOptions=[]
        this.details_form1.cprovince=''
        this.details_form1.ccity=''
        this.details_form1.cfax=''
        this.details_form1.street4Post=''
        this.details_form1.allAddress4Post=''
        this.details_form1.contact4Post=''
        this.details_form1.receiver4Post=''
        this.details_form1.stop4Post=''
        this.details_form1.notes4Post=''
      },
      //修改出库单前置
      edit_stock(){
        this.row_first_now=[]
        this.details_form1.addTime4Post=this.publicAjax.genDateFromStamp(new Date().getTime())
        this.stock_add_edit_check='edit'
        //出库明细表单禁用状态
        this.orderType_status=false
        this.customerId_status=false
        this.soReference_status=false
        this.addTime_status=false
        this.consigneeId_status=false
        this.consigneeName_status=false
        this.needFHTime_status=false
        this.warehouseid_status=false
        this.selectedOptions_status=false
        this.street_status=false
        this.allAddress_status=false
        this.contact_status=false
        this.receiver_status=false
        this.stop_status=false
        this.notes_status=false
        if(this.row_stock_now.auditFlag=='N'){
          this.add_stock_status=true
          this.edit_stock_status=true
          this.delete_stock_status=true
          this.save_stock_status=false
          this.cancel_stock_status=false
          this.check_stock_status=false
        }else{
          this.add_stock_status=true
          this.edit_stock_status=true
          this.delete_stock_status=true
          this.save_stock_status=false
          this.cancel_stock_status=false
          this.check_stock_status=true
        }
        //出库明细表单新增正则
        this.stock_rules=this.stock_rules_add
        //重置出库明细表单校验
        this.$refs.details_form1.clearValidate()
      },
      //新增或修改出库单保存
      save_stock(){
        let that=this
        that.$refs.details_form1.validate((valid)=>{
          if(valid){
            if(that.stock_add_edit_check=='add'){
              that.$axios({
                method:'post',
                url:that.publicAjax.extra_path+'/datahub/so/head',
                headers:{
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "content-type":"application/json;charset=UTF-8"
                },
                data:{
                  orderType:that.details_form1.orderType4Post,
                  customerId:that.details_form1.customerId4Post,
                  soReference1:that.details_form1.soReference4Post,
                  orderTime:that.details_form1.addTime4Post,
                  consigneeId:that.details_form1.consigneeId4Post,
                  consigneeName:that.details_form1.consigneeName4Post,
                  notes:that.details_form1.notes4Post,
                  requiredDeliveryTime:that.details_form1.needFHTime4Post,
                  stop:that.details_form1.stop4Post,
                  warehouseId:that.details_form1.warehouseid4Post,
                  cprovince:CodeToText[that.details_form1.selectedOptions[0]],
                  ccity:CodeToText[that.details_form1.selectedOptions[1]],
                  cfax:CodeToText[that.details_form1.selectedOptions[2]],
                  caddress1:that.details_form1.allAddress4Post,
                  caddress2:that.details_form1.street4Post,
                  ccontact:that.details_form1.receiver4Post,
                  ctel1:that.details_form1.contact4Post
                }
              }).then(data=>{
                if(data.data.success==true){
                  that.row_first_now.push(data.data.data)
                  //获取出库单列表
                  that.get_stock()
                  that.$message.success(data.data.message)
                }else{
                  that.$message.warning(data.data.message)
                }
              })
            }else if(that.stock_add_edit_check=='edit'){
              that.$axios({
                method:'put',
                url:that.publicAjax.extra_path+'/datahub/so/head/'+that.row_stock_now.headId,
                headers:{
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "content-type":"application/json;charset=UTF-8"
                },
                data:{
                  orderType:that.details_form1.orderType4Post,
                  customerId:that.details_form1.customerId4Post,
                  soReference1:that.details_form1.soReference4Post,
                  orderTime:that.details_form1.addTime4Post,
                  consigneeId:that.details_form1.consigneeId4Post,
                  consigneeName:that.details_form1.consigneeName4Post,
                  notes:that.details_form1.notes4Post,
                  requiredDeliveryTime:that.details_form1.needFHTime4Post,
                  stop:that.details_form1.stop4Post,
                  warehouseId:that.details_form1.warehouseid4Post,
                  cprovince:CodeToText[that.details_form1.selectedOptions[0]],
                  ccity:CodeToText[that.details_form1.selectedOptions[1]],
                  cfax:CodeToText[that.details_form1.selectedOptions[2]],
                  caddress1:that.details_form1.allAddress4Post,
                  caddress2:that.details_form1.street4Post,
                  ccontact:that.details_form1.receiver4Post,
                  ctel1:that.details_form1.contact4Post
                }
              }).then(data=>{
                if(data.data.success==true){
                  that.row_first_now.push(data.data.data)
                  //获取出库单列表
                  that.get_stock()
                  that.$message.success(data.data.message)
                }else{
                  that.$message.warning(data.data.message)
                }
              })
            }
          }else{
            return false
          }
        })
      },
      //删除出库单
      delete_stock(){
        if(this.list_data.length==0){
          this.$message.warning('暂无数据!')
          return false
        }
        let that=this
        that.$confirm('是否继续?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'delete',
            url:that.publicAjax.extra_path+'/datahub/so/head/'+that.row_stock_now.headId
          }).then(data=>{
            if(data.data.success==true){
              that.row_first_now=[]
              //获取出库单列表
              that.get_stock()
              that.$message.success(data.data.message)
            }else{
              that.$message.warning(data.data.message)
            }
          })
        }).catch(()=>{

        })
      },
      //审核出库单
      check_stock(){
        this.stock_add_edit_check='check'
        let that=this
        that.$confirm('是否继续?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'put',
            url:that.publicAjax.extra_path+'/datahub/so/audit/'+that.row_stock_now.headId
          }).then(data=>{
            if(data.data.success==true){
              //获取出库单列表
              that.get_stock()
              that.$message.success(data.data.message)
            }else{
              that.$message.warning(data.data.message)
            }
          })
        }).catch(()=>{

        })
      },
      //取消新增或修改出库单
      cancel_stock(){
        //出库单明细行双击事件
        this.db_detail_list(this.row_stock_now)
      },
      //获取出库单子表列表
      get_stock_child(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/datahub/so/detailList',
          params:{
            page:that.out_current_page,
            limit:that.out_page_size,
            headId:that.row_stock_now.headId,
            orderNo:that.row_stock_now.orderNo
          }
        }).then(data=>{
          if(data.data.success==true){
            that.list_detail_data=data.data.data.list
            that.out_total=data.data.data.total
            if(that.child_add_edit=='edit'){
              that.list_detail_data.forEach(item=>{
                if(item.detailId==that.row_child_now.detailId){
                  that.row_child_now=item
                }
              })
              that.db_details(that.row_child_now)
            }else{
              that.db_details(that.list_detail_data[0])
            }
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //获取批次属性要求
      get_batch(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/wms/orderBase/lot/'+that.row_stock_now.customerId
        }).then(data=>{
          if(data.data.success==true){
            that.detail_detail_form.batch_list=data.data.data
            that.detail_detail_form.batch_list.forEach(item=>{
              that.$set(item,'lotAtt','')
              that.$set(item,'batch_status',true)
            })
            //子表明细表单回显
            that.detail_detail_form.soLineNo=that.row_child_now.orderLineNo,
            that.detail_detail_form.lineStatus=that.row_child_now.lineStatus,
            that.detail_detail_form.sku=that.row_child_now.sku,
            that.detail_detail_form.descrc=that.row_child_now.descrc,
            that.detail_detail_form.descre=that.row_child_now.descre,
            that.detail_detail_form.uom=that.row_child_now.uom,
            that.detail_detail_form.qtyOrderedEach=that.row_child_now.qtyOrderedEach,
            that.detail_detail_form.saveQty=''
            that.detail_detail_form.batch_list[0].lotAtt=that.row_child_now.lotAtt01
            that.detail_detail_form.batch_list[1].lotAtt=that.row_child_now.lotAtt02
            that.detail_detail_form.batch_list[2].lotAtt=that.row_child_now.lotAtt03
            that.detail_detail_form.batch_list[3].lotAtt=that.row_child_now.lotAtt04
            that.detail_detail_form.batch_list[4].lotAtt=that.row_child_now.lotAtt05
            that.detail_detail_form.batch_list[5].lotAtt=that.row_child_now.lotAtt06
            that.detail_detail_form.batch_list[6].lotAtt=that.row_child_now.lotAtt07
            that.detail_detail_form.batch_list[7].lotAtt=that.row_child_now.lotAtt08
            that.detail_detail_form.batch_list[8].lotAtt=that.row_child_now.lotAtt09
            that.detail_detail_form.batch_list[9].lotAtt=that.row_child_now.lotAtt10
            that.detail_detail_form.batch_list[10].lotAtt=that.row_child_now.lotAtt11
            that.detail_detail_form.batch_list[11].lotAtt=that.row_child_now.lotAtt12
            //重置子表明细表单校验
            this.$refs.detail_detail_form.clearValidate()
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //出库单列表详情分页
      out_size_change(val){
        this.out_page_size=val
        //获取出库单子表列表
        this.get_stock_child()
      },
      out_current_change(val){
        this.out_current_page=val
        //获取出库单子表列表
        this.get_stock_child()
      },
      //选择产品弹框
      to_sku(){
        this.productVisible=true
        //获取产品列表
        this.get_product()
      },
      //获取产品列表
      get_product(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/wms/order/stockSku/'+that.row_stock_now.customerId+'/'+that.row_stock_now.warehouseId+'/'+that.row_stock_now.headId,
          params:{
            page:that.product_current_page,
            limit:that.product_page_size,
            key:that.productKey
          }
        }).then(data=>{
          if(data.data.success==true){
            that.product_data=data.data.data.list
            that.product_total=data.data.data.total
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //产品列表多行高亮显示
      row_class({row,rowIndex}){
        if(row.shadow==true){
          return {'background':'rgba(185, 221, 249, 0.75)'}
        }
      },
      //双击产品列表
      db_product(row,column,event){
        this.productVisible=false
        this.detail_detail_form.sku=row.sku
        this.detail_detail_form.descrc=row.descrc
        this.detail_detail_form.descre=row.descre
        this.detail_detail_form.uom=row.alternateSku3
        this.detail_detail_form.batch_list[0].lotAtt=row.lotAtt01
        this.detail_detail_form.batch_list[1].lotAtt=row.lotAtt02
        this.detail_detail_form.batch_list[2].lotAtt=row.lotAtt03
        this.detail_detail_form.batch_list[3].lotAtt=row.lotAtt04
        this.detail_detail_form.batch_list[4].lotAtt=row.lotAtt05
        this.detail_detail_form.batch_list[5].lotAtt=row.lotAtt06
        this.detail_detail_form.batch_list[6].lotAtt=row.lotAtt07
        this.detail_detail_form.batch_list[7].lotAtt=row.lotAtt08
        this.detail_detail_form.batch_list[8].lotAtt=row.lotAtt09
        this.detail_detail_form.batch_list[9].lotAtt=row.lotAtt10
        this.detail_detail_form.batch_list[10].lotAtt=row.lotAtt11
        this.detail_detail_form.batch_list[11].lotAtt=row.lotAtt12
      },
      //查询产品列表
      search_product(){
        this.product_current_page=1
        this.product_page_size=10
        //获取产品列表
        this.get_product()
      },
      //产品列表分页
      product_current_change(val){
        this.product_current_page=val
        //获取产品列表
        this.get_product()
      },
      product_size_change(val){
        this.product_page_size=val
        //获取产品列表
        this.get_product()
      },
      //出库单子表双击事件
      detail_check_detail(row,column,event){
        this.new_active='2'
        //出库单子表明细行双击事件
        this.db_details(row,column,event)
      },
      //出库单子表明细行双击事件
      db_details(row,column,event){
        this.child_add_edit=''
        this.child_rules={}
        //出库单子表明细表单禁用状态
        this.detailId_status=true
        this.lineStatus_status=true
        this.sku_status=true
        this.skuDescrC_status=true
        this.skuDescrE_status=true
        this.uom_status=true
        this.expectedQty_status=true
        this.saveQty_status=true
        if(this.row_stock_now.auditFlag=='N'){
          this.child_add_status=false
          this.child_edit_status=false
          this.child_delete_status=false
          this.child_save_status=true
          this.child_cancel_status=true
          this.child_download_status=false
          this.child_upload_status=false
        }else{
          this.child_add_status=true
          this.child_edit_status=true
          this.child_delete_status=true
          this.child_save_status=true
          this.child_cancel_status=true
          this.child_download_status=false
          this.child_upload_status=true
        }
        //获取批次属性要求
        this.get_batch()
        if(row==undefined){
          //重置子表明细当前行数据
          this.row_child_now={}
          return false
        }
        //获取子表明细当前行数据
        this.row_child_now=row
        //选中当前行
        this.$refs.stock_child_details.setCurrentRow(row)
      },
      //新增子表前置
      child_add(){
        this.child_add_edit='add'
        //出库子表表单禁用状态
        this.sku_status=false
        this.skuDescrC_status=false
        this.skuDescrE_status=false
        this.uom_status=false
        this.expectedQty_status=false
        this.detail_detail_form.batch_list.forEach(item=>{
          this.$set(item,'batch_status',false)
        })
        if(this.row_stock_now.auditFlag=='N'){
          this.child_add_status=true
          this.child_edit_status=true
          this.child_delete_status=true
          this.child_save_status=false
          this.child_cancel_status=false
          this.child_download_status=false
          this.child_upload_status=false
        }else{
          this.child_add_status=true
          this.child_edit_status=true
          this.child_delete_status=true
          this.child_save_status=true
          this.child_cancel_status=true
          this.child_download_status=false
          this.child_upload_status=true
        }
        //出库子表表单新增正则
        this.child_rules=this.child_rules_add
        //重置出库子表明细表单
        this.detail_detail_form.soLineNo=''
        this.detail_detail_form.lineStatus=''
        this.detail_detail_form.sku=''
        this.detail_detail_form.descrc=''
        this.detail_detail_form.descre=''
        this.detail_detail_form.uom=''
        this.detail_detail_form.qtyOrderedEach=''
        this.detail_detail_form.saveQty=''
        this.detail_detail_form.batch_list[0].lotAtt=''
        this.detail_detail_form.batch_list[1].lotAtt=''
        this.detail_detail_form.batch_list[2].lotAtt=''
        this.detail_detail_form.batch_list[3].lotAtt=''
        this.detail_detail_form.batch_list[4].lotAtt=''
        this.detail_detail_form.batch_list[5].lotAtt=''
        this.detail_detail_form.batch_list[6].lotAtt=''
        this.detail_detail_form.batch_list[7].lotAtt=''
        this.detail_detail_form.batch_list[8].lotAtt=''
        this.detail_detail_form.batch_list[9].lotAtt=''
        this.detail_detail_form.batch_list[10].lotAtt=''
        this.detail_detail_form.batch_list[11].lotAtt=''
      },
      //修改子表前置
      child_edit(){
        this.child_add_edit='edit'
        //出库子表表单禁用状态
        this.sku_status=false
        this.skuDescrC_status=false
        this.skuDescrE_status=false
        this.uom_status=false
        this.expectedQty_status=false
        this.detail_detail_form.batch_list.forEach(item=>{
          this.$set(item,'batch_status',false)
        })
        if(this.row_stock_now.auditFlag=='N'){
          this.child_add_status=true
          this.child_edit_status=true
          this.child_delete_status=true
          this.child_save_status=false
          this.child_cancel_status=false
          this.child_download_status=false
          this.child_upload_status=false
        }else{
          this.child_add_status=true
          this.child_edit_status=true
          this.child_delete_status=true
          this.child_save_status=true
          this.child_cancel_status=true
          this.child_download_status=false
          this.child_upload_status=true
        }
        //出库子表表单修改正则
        this.child_rules=this.child_rules_add
        //重置出库明细表单校验
        this.$refs.detail_detail_form.clearValidate()
      },
      //新增出库子表保存
      child_save(){
        let that=this
        that.$refs.detail_detail_form.validate((valid)=>{
          if(valid){
            if(that.child_add_edit=='add'){
              that.$axios({
                method:'post',
                url:that.publicAjax.extra_path+'/datahub/so/detail/'+that.row_stock_now.headId,
                headers:{
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "content-type":"application/json;charset=UTF-8"
                },
                data:{
                  sku:that.detail_detail_form.sku,
                  descrc:that.detail_detail_form.descrc,
                  descre:that.detail_detail_form.descre,
                  qtyOrderedEach:that.detail_detail_form.qtyOrderedEach,
                  uom:that.detail_detail_form.uom,
                  lotAtt01:that.detail_detail_form.batch_list[0].status!='1'?that.detail_detail_form.batch_list[0].lotAtt:'0',
                  lotAtt02:that.detail_detail_form.batch_list[1].status!='1'?that.detail_detail_form.batch_list[1].lotAtt:'0',
                  lotAtt03:that.detail_detail_form.batch_list[2].status!='1'?that.detail_detail_form.batch_list[2].lotAtt:'0',
                  lotAtt04:that.detail_detail_form.batch_list[3].status!='1'?that.detail_detail_form.batch_list[3].lotAtt:'0',
                  lotAtt05:that.detail_detail_form.batch_list[4].status!='1'?that.detail_detail_form.batch_list[4].lotAtt:'0',
                  lotAtt06:that.detail_detail_form.batch_list[5].status!='1'?that.detail_detail_form.batch_list[5].lotAtt:'0',
                  lotAtt07:that.detail_detail_form.batch_list[6].status!='1'?that.detail_detail_form.batch_list[6].lotAtt:'0',
                  lotAtt08:that.detail_detail_form.batch_list[7].status!='1'?that.detail_detail_form.batch_list[7].lotAtt:'0',
                  lotAtt09:that.detail_detail_form.batch_list[8].status!='1'?that.detail_detail_form.batch_list[8].lotAtt:'0',
                  lotAtt10:that.detail_detail_form.batch_list[9].status!='1'?that.detail_detail_form.batch_list[9].lotAtt:'0',
                  lotAtt11:that.detail_detail_form.batch_list[10].status!='1'?that.detail_detail_form.batch_list[10].lotAtt:'0',
                  lotAtt12:that.detail_detail_form.batch_list[11].status!='1'?that.detail_detail_form.batch_list[11].lotAtt:'0'
                }
              }).then(data=>{
                if(data.data.success==true){
                  //获取出库单子表列表
                  that.get_stock_child()
                  that.$message.success(data.data.message)
                }else{
                  that.$message.warning(data.data.message)
                }
              })
            }else if(that.child_add_edit=='edit'){
              if(that.list_detail_data.length==0){
                that.$message.warning('暂无可修改数据!')
                return false
              }
              that.$axios({
                method:'put',
                url:that.publicAjax.extra_path+'/datahub/so/detail/'+that.row_stock_now.headId+'/'+that.row_child_now.detailId,
                headers:{
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "content-type":"application/json;charset=UTF-8"
                },
                data:{
                  sku:that.detail_detail_form.sku,
                  descrc:that.detail_detail_form.descrc,
                  descre:that.detail_detail_form.descre,
                  qtyOrderedEach:that.detail_detail_form.qtyOrderedEach,
                  uom:that.detail_detail_form.uom,
                  lotAtt01:that.detail_detail_form.batch_list[0].status!='1'?that.detail_detail_form.batch_list[0].lotAtt:'0',
                  lotAtt02:that.detail_detail_form.batch_list[1].status!='1'?that.detail_detail_form.batch_list[1].lotAtt:'0',
                  lotAtt03:that.detail_detail_form.batch_list[2].status!='1'?that.detail_detail_form.batch_list[2].lotAtt:'0',
                  lotAtt04:that.detail_detail_form.batch_list[3].status!='1'?that.detail_detail_form.batch_list[3].lotAtt:'0',
                  lotAtt05:that.detail_detail_form.batch_list[4].status!='1'?that.detail_detail_form.batch_list[4].lotAtt:'0',
                  lotAtt06:that.detail_detail_form.batch_list[5].status!='1'?that.detail_detail_form.batch_list[5].lotAtt:'0',
                  lotAtt07:that.detail_detail_form.batch_list[6].status!='1'?that.detail_detail_form.batch_list[6].lotAtt:'0',
                  lotAtt08:that.detail_detail_form.batch_list[7].status!='1'?that.detail_detail_form.batch_list[7].lotAtt:'0',
                  lotAtt09:that.detail_detail_form.batch_list[8].status!='1'?that.detail_detail_form.batch_list[8].lotAtt:'0',
                  lotAtt10:that.detail_detail_form.batch_list[9].status!='1'?that.detail_detail_form.batch_list[9].lotAtt:'0',
                  lotAtt11:that.detail_detail_form.batch_list[10].status!='1'?that.detail_detail_form.batch_list[10].lotAtt:'0',
                  lotAtt12:that.detail_detail_form.batch_list[11].status!='1'?that.detail_detail_form.batch_list[11].lotAtt:'0'
                }
              }).then(data=>{
                if(data.data.success==true){
                  //获取出库单子表列表
                  that.get_stock_child()
                  that.$message.success(data.data.message)
                }else{
                  that.$message.warning(data.data.message)
                }
              })
            }
          }else{
            return false
          }
        })
      },
      //删除出库单子表
      child_delete(){
        if(this.list_detail_data.length==0){
          this.$message.warning('暂无可删除数据!')
          return false
        }
        let that=this
        that.$confirm('是否继续?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'delete',
            url:that.publicAjax.extra_path+'/datahub/so/detail/'+that.row_stock_now.headId+'/'+that.row_child_now.detailId
          }).then(data=>{
            if(data.data.success==true){
              //获取出库子表列表
              that.get_stock_child()
              that.$message.success(data.data.message)
            }else{
              that.$message.warning(data.data.message)
            }
          })
        }).catch(()=>{

        })
      },
      //取消出库单子表操作
      child_cancel(){
        //出库单子表明细行双击事件
        this.db_details(this.row_child_now)
      },
      //出库单子表模板下载
      child_download(){
        let that=this
        let url='/datahub/so/template/'+that.row_stock_now.customerId
        let xmlResquest=new XMLHttpRequest()
        xmlResquest.open('GET',this.publicAjax.extra_path+url,true)
        //设置请求头类型
        xmlResquest.setRequestHeader("Content-type", "application/json")
        xmlResquest.setRequestHeader("scctoken",localStorage.getItem(localStorage.getItem('userName')+'token'))
        xmlResquest.responseType="blob"
        xmlResquest.onreadystatechange=function(){
          if(xmlResquest.status===200){
            if(xmlResquest.readyState===4){
              var content=xmlResquest.response
              if(content.size==104){
                that.$message.warning('暂未授权，无权操作,请联系管理员！')
              }else{
                var elink=document.createElement('a')
                elink.download="出库明细模板.xls"
                elink.style.display='none'
                var blob=new Blob([content])
                elink.href=URL.createObjectURL(blob)
                document.body.appendChild(elink)
                elink.click()
                document.body.removeChild(elink)
              }
            }
          }
        }
        xmlResquest.send()
        return false
      },
      //出库单子表明细上传回调
      success_file(data,file,fileList){
        if(data.success==false){
          this.$message.error(data.message)
        }else{
          this.$message.success(data.message)
          //出库单明细行双击事件
          this.db_detail_list(this.row_stock_now)
        }
      }
    }
  }
</script>

<style scoped="scoped">
  /* 查询表单 */
  .search_form .el-form-item{
    width: 49%;
    display: inline-block;
  }
  .details_form1 .el-form-item,
  .detail_detail_form .el-form-item{
    width: 32%;
    display: inline-block;
  }
  @media screen and (max-width:720px) {
    .search_form .el-form-item,
    .details_form1 .el-form-item{
      width: 100%;
    }
  }
  .details_form1 .form1_other,
  .detail_detail_form .form1_other{
    width: 100%;
  }
  .form1_other div{
     display: inline-block;
  }
  /* 出库单明细 */
  .operate_btn{
    margin-right: 0px;
  }
  .operate_btn+.operate_btn{
    margin-left: 0px;
  }
  .el_details_row{
    display: flex;
    justify-content: space-between;
  }
  .db_detail_list{
    width: 30%;
  }
  .details_form1,
  .detail_detail_form{
    width: 68%;
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/order/stock_out.vue